import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	server: {
		SERVER_URL: z.string().url().optional(),
		STRAPI_WRITE_TOKEN: z.string().min(1),
	},

	/**
	 * The prefix that client-side variables must have. This is enforced both at
	 * a type-level and at runtime.
	 */
	clientPrefix: "VITE_",

	client: {
		VITE_APP_TITLE: z.string().min(1).optional(),
		VITE_STRAPI_API_TOKEN: z.string().min(1),
		VITE_STRAPI_BASE_URL: z.string().url(),
	},

	/**
	 * Vite only exposes VITE_-prefixed vars in import.meta.env.
	 * Server-only vars must be mapped from process.env here (this is the one
	 * place where process.env is appropriate — the T3Env bootstrap itself).
	 */
	runtimeEnv: {
		VITE_APP_TITLE:
			import.meta.env.VITE_APP_TITLE || process.env.VITE_APP_TITLE,
		VITE_STRAPI_API_TOKEN:
			import.meta.env.VITE_STRAPI_API_TOKEN ||
			process.env.VITE_STRAPI_API_TOKEN,
		VITE_STRAPI_BASE_URL:
			import.meta.env.VITE_STRAPI_BASE_URL || process.env.VITE_STRAPI_BASE_URL,
		SERVER_URL: process.env.SERVER_URL,
		STRAPI_WRITE_TOKEN: process.env.STRAPI_WRITE_TOKEN,
	},

	/**
	 * By default, this library will feed the environment variables directly to
	 * the Zod validator.
	 *
	 * This means that if you have an empty string for a value that is supposed
	 * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
	 * it as a type mismatch violation. Additionally, if you have an empty string
	 * for a value that is supposed to be a string with a default value (e.g.
	 * `DOMAIN=` in an ".env" file), the default value will never be applied.
	 *
	 * In order to solve these issues, we recommend that all new projects
	 * explicitly specify this option as true.
	 */
	emptyStringAsUndefined: true,

	/**
	 * Tell T3 Env to use the server schema only on the server.
	 */
	isServer: import.meta.env.SSR,
});
